'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var START_BIN = exports.START_BIN = '1010';
var END_BIN = exports.END_BIN = '11101';

var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];


//////////////////
// WEBPACK FOOTER
// ./~/jsbarcode/bin/barcodes/ITF/constants.js
// module id = 629
// module chunks = 1